import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import { ErrorBoundary } from "./components/ErrorBoundary.tsx";
import "./index.css";

const rootElement = document.getElementById("root");

if (!rootElement) {
  // Fail gracefully — never a blank white screen
  document.body.innerHTML = `
    <div style="display:flex;align-items:center;justify-content:center;min-height:100vh;
                font-family:system-ui,sans-serif;background:#f8f9fa;color:#343a40;padding:2rem;">
      <div style="text-align:center;max-width:400px;">
        <h1 style="margin-bottom:1rem;font-size:1.5rem;">App failed to load</h1>
        <p style="margin-bottom:1.5rem;color:#6c757d;">
          The application could not start. Please refresh the page.
          If this persists, contact support.
        </p>
        <button onclick="window.location.reload()"
          style="padding:.5rem 1.5rem;background:#0d6efd;color:#fff;border:none;
                 border-radius:.375rem;cursor:pointer;font-size:1rem;">
          Reload Page
        </button>
      </div>
    </div>`;
  throw new Error("[ApneDoctors] Root element #root not found in document.");
}

createRoot(rootElement).render(
  <StrictMode>
    <ErrorBoundary label="AppRoot">
      <App />
    </ErrorBoundary>
  </StrictMode>
);
